import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import NotFound from '@/components/NotFound'

import globals from '@/globals'

// Layouts
import Layout2 from '@/layout/Layout2'
// import Layout2 from '@/layout/LayoutHorizontalSidenav'
import LayoutBlank from '@/layout/LayoutBlank'

import store from '../store/index'

Vue.use(Router)
Vue.use(Meta)

const router = new Router({
  base: '/',
  mode: 'history',
  routes: [{
    path: '/',
    component: Layout2,
    meta: {
      requiresAuth: true
    },
    children: [{
      path: '',
      component: () => import('@/components/Home')
    }, {
      path: 'page-2',
      component: () => import('@/components/Page2')
    }, {
      path: 'accounts',
      component: () => import('@/components/accounts/Account.vue')
    }, {
      path: 'accounts/info',
      component: () => import('@/components/accounts/AccountInfo.vue')
    }, {
      path: 'applications',
      component: () => import('@/components/applications/ApplicationsYears.vue')
    }, {
      path: 'applications/:applicationId',
      component: () => import('@/components/applications/Applications.vue')
    }, {
      path: 'applications/:applicationId/:id/:createdAt',
      name: 'applications',
      component: () => import('@/components/applications/ApplicationView.vue')
    }, {
      path: 'sections',
      component: () => import('@/components/grades/Grades.vue')
    }, {
      path: 'sections/view/:id',
      component: () => import('@/components/grades/GradeView.vue')
    }, {
      path: 'learners',
      component: () => import('@/components/learners/Learners.vue')
    }, {
      path: 'learners/view/:id',
      component: () => import('@/components/learners/LearnerView.vue')
    }, {
      path: 'learners/add',
      component: () => import('@/components/learners/LearnerView.vue')
    }, {
      path: 'learners/import',
      component: () => import('@/components/learners/import/Import.vue')
    }, {
      path: 'learners/cemisimport',
      component: () => import('@/components/learners/cemisimport/Import.vue')
    }, {
      path: 'learners/cemisimportget',
      component: () => import('@/components/learners/cemisimportget/Import.vue')
    }, {
      path: 'educators',
      component: () => import('@/components/educators/Educators.vue')
    }, {
      path: 'educators/view/:id',
      component: () => import('@/components/educators/EducatorView.vue')
    }, {
      path: 'educators/add',
      component: () => import('@/components/educators/EducatorView.vue')
    }, {
      path: 'guardians',
      component: () => import('@/components/guardians/Guardians.vue')
    }, {
      path: 'guardians/view/:id',
      component: () => import('@/components/guardians/GuardianView.vue')
    }, {
      path: 'guardians/add',
      component: () => import('@/components/guardians/GuardianView.vue')
    }, {
      path: 'subjects',
      component: () => import('@/components/subjects/Subjects.vue')
    }, {
      path: 'subjects/learners',
      component: () => import('@/components/subjects/Learners.vue')
    }, {
      path: 'subjects/:id',
      component: () => import('@/components/subjects/SubjectView.vue')
    }, {
      path: 'assessments/:id',
      component: () => import('@/components/subjects/Assessments.vue')
    }, {
      path: 'marks/assessments/capture',
      component: () => import('@/components/marks/LearnerAssessments.vue')
    }, {
      path: 'marks/results/capture',
      component: () => import('@/components/marks/CaptureResults.vue')
    }, {
      path: 'marks/results',
      component: () => import('@/components/marks/LearnerResults.vue')
    }, {
      path: 'marks/outstanding',
      component: () => import('@/components/outstandingmarks/OutStandingMarks.vue')
    }, {
      path: '/marks/import',
      component: () => import('@/components/importmarks/ImportMarks.vue')
    }, {
      path: '/markbook',
      component: () => import('@/components/markbook/Subjects.vue')
    }, {
      path: '/markbook/:id',
      component: () => import('@/components/markbook/Markbook.vue')
    }, {
      path: 'courses',
      component: () => import('@/components/courses/Courses.vue')
    }, {
      path: 'classes',
      component: () => import('@/components/educatorsections/EducatorSections.vue')
    }, {
      path: 'attendance/daily',
      component: () => import('@/components/attendances/DailyAttendance.vue')
    }, {
      path: 'attendance/daily/overview',
      component: () => import('@/components/attendances/AttendanceOverviewClassSelect.vue')
    }, {
      path: 'attendance/daily/section/:sectionId',
      component: () => import('@/components/attendances/AttendanceOverview.vue')
    }, {
      path: 'attendance/daily/learner/:learnerId',
      component: () => import('@/components/attendances/LearnerAttendance.vue')
    }, {
      path: 'attendance/quarterly',
      component: () => import('@/components/attendances/QuarterlyAttendance.vue')
    }, {
      path: 'subjectcomments',
      component: () => import('@/components/comments/SubjectComments.vue')
    }, {
      path: 'classcomments',
      component: () => import('@/components/comments/ClassComments.vue')
    }, {
      path: 'nonacademiccomments',
      component: () => import('@/components/comments/NonAcademicComments.vue')
    }, {
      path: 'templatecomments',
      component: () => import('@/components/comments/TemplateComments.vue')
    }, {
      path: 'reports/class',
      component: () => import('@/components/reports/ClassReport.vue')
    }, {
      path: 'reports/grade',
      component: () => import('@/components/reports/GradeReport.vue')
    }, {
      path: 'reports/settings',
      component: () => import('@/components/reports/ReportSettings.vue')
    }, {
      path: 'transcripts',
      component: () => import('@/components/transcripts/Transcript.vue')
    }, {
      path: 'analysis',
      component: () => import('@/components/analysis/Analysis.vue')
    }, {
      path: 'graderanking',
      component: () => import('@/components/analysis/GradeRanking.vue')
    }, {
      path: 'classranking',
      component: () => import('@/components/analysis/ClassRanking.vue')
    }, {
      path: 'pass-overview',
      component: () => import('@/components/analysis/PassOverview.vue')
    }, {
      path: 'finance',
      component: () => import('@/components/finances/Finance.vue')
    }, {
      path: 'finance/capture',
      component: () => import('@/components/finances/capture/Capture.vue')
    }, {
      path: 'finance/capture/:id',
      component: () => import('@/components/finances/capture/CaptureView.vue')
    }, {
      path: 'finance/settings',
      component: () => import('@/components/finances/settings/Settings.vue')
    }, {
      path: 'finance/learners',
      component: () => import('@/components/finances/learners/Learners.vue')
    }, {
      path: 'statement',
      component: () => import('@/components/finances/Statement.vue')
    }, {
      path: 'emailstatement',
      component: () => import('@/components/finances/email/StatementEmail.vue')
    }, {
      path: 'emailstatementhistory',
      component: () => import('@/components/finances/email/EmailHistory.vue')
    }, {
      path: 'finalschedule',
      component: () => import('@/components/finalschedule/FinalSchedule.vue')
    }, {
      path: 'emailreports',
      component: () => import('@/components/reports/ReportEmail.vue')
    }, {
      path: 'emailreports/grade',
      component: () => import('@/components/reports/ReportEmailGrade.vue')
    }, {
      path: 'emailreportshistory',
      component: () => import('@/components/reports/EmailHistory.vue')
    }, {
      path: 'incidentsettings',
      component: () => import('@/components/incidentsettings/IncidentSettings.vue')
    }, {
      path: 'incidents',
      component: () => import('@/components/incidents/Incidents.vue')
    }, {
      path: 'incidents/incident',
      component: () => import('@/components/incidents/IncidentView.vue')
    }, {
      path: 'incidents/views/:id',
      component: () => import('@/components/incidents/IncidentView.vue')
    }, {
      path: 'incidents/reporting',
      component: () => import('@/components/incidents/IncidentReports.vue')
    }, {
      path: 'meetingsettings',
      component: () => import('@/components/meetingsettings/MeetingSettings.vue')
    }, {
      path: 'meetings',
      component: () => import('@/components/meetings/Meetings.vue')
    }, {
      path: 'meetings/meeting',
      component: () => import('@/components/meetings/MeetingView.vue')
    }, {
      path: 'meetings/views/:id',
      component: () => import('@/components/meetings/MeetingView.vue')
    }]
  }, {
    path: '/auth',
    component: LayoutBlank,
    children: [{
      path: '',
      component: () => import('@/components/auth/Login')
    }, {
      path: 'reset-password',
      component: () => import('@/components/auth/ResetPassword')
    }, {
      path: 'reset-email-sent',
      component: () => import('@/components/auth/ResetEmailSent')
    }, {
      path: 'change-password',
      component: () => import('@/components/auth/ChangePassword')
    }, {
      path: 'change-password-complete',
      component: () => import('@/components/auth/ChangePasswordComplete')
    }]
  }, {
    // 404 Not Found page
    path: '*',
    component: NotFound
  }]
})

router.afterEach(() => {
  // On small screens collapse sidenav
  if (window.layoutHelpers && window.layoutHelpers.isSmallScreen() && !window.layoutHelpers.isCollapsed()) {
    setTimeout(() => window.layoutHelpers.setCollapsed(true, true), 10)
  }

  // Scroll to top of the page
  globals().scrollTop(0, 0)
})

router.beforeEach((to, from, next) => {
  // Set loading state
  document.body.classList.add('app-loading')
  // Add tiny timeout to finish page transition
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  if (requiresAuth) {
    if (store.getters['auth/isLoggedIn']) {
      next()
      // setTimeout(() => next(), 10)
      return
    }
    next('/auth')
  } else {
    next()
    // setTimeout(() => next(), 10)
  }
})

export default router
